import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

// Async thunk for sending notifications all user
export const sendNotificationAllUser = createAsyncThunk(
  'notifications/send',
  async ({notificationData}, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${apiUrl}/SendBulkNotification/`,
        notificationData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          }
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 
        'Failed to send notification'
      );
    }
  }
);

// Initial state
const initialState = {
  isLoading: false,
  error: null,
  lastSentNotification: null
};

// Slice
const notificationSlice = createSlice({
  name: 'notificationsAllUsers',
  initialState,
  reducers: {
    clearNotificationError: (state) => {
      state.error = null;
    },
    clearLastSentNotification: (state) => {
      state.lastSentNotification = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendNotificationAllUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(sendNotificationAllUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.lastSentNotification = action.payload;
      })
      .addCase(sendNotificationAllUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  }
});

// Export actions and reducer
export const { clearNotificationError, clearLastSentNotification } = notificationSlice.actions;
export default notificationSlice.reducer;